import axios from 'axios'

export default class IALoadMore {
    /**
     * @param {Object} options This is an object to instanciate the load more
     * @param {String} options.post_type You have to provide the post type to load
     * @param {Number} options.page_to_load Number of page to load
     * @param {HTMLElement} options.item Provide the item to clone
     * @param {Number} options.per_page Number of element to display
     * @param {Number} options.maxpage Maximum of pages
     * @param {String} options.lang Provide the lang
     * @param {String} [options.image] Selector of the image
     * @param {String} [options.title] Selector of the title
     * @param {String} [options.excerpt] Selector of excerpt
     * @param {String} [options.date] Selector of date
     */
    constructor(
        options = {
            post_type: 'posts', 
            page_to_load: Number(document.querySelector('.ia-block-latest-post').dataset.page) + 1,
            item: document.querySelector('.latest-post-slide'), 
            per_page: Number(document.querySelector('.ia-block-latest-post').dataset.perpage),
            maxpage: Number(document.querySelector('.ia-block-latest-post').dataset.maxpages),
            lang: document.querySelector('html').lang,
            image:'.ia-block-latest-post__featured-image img',
            title: '.ia-block-latest-post__title-news',
            excerpt: '.ia-block-latest-post__excerpt',
            date: undefined,
        }
    ) {
        this.options = options
        if(options.page_to_load <= options.maxpage){
            this.getPosts()
            document.querySelector('.ia-block-latest-post').dataset.page = Number(document.querySelector('.ia-block-latest-post').dataset.page) + 1
            if(options.page_to_load == options.maxpage){
                options.item.parentElement.parentElement.querySelector('.wp-block-buttons button').disabled = true;
            }
        }else{
            options.item.parentElement.parentElement.querySelector('.wp-block-buttons button').disabled = true;
        }
    }

    async getPosts() {
        const url = '/wp-json/wp/v2/'+ this.options.post_type 
            + '?per_page='+ this.options.per_page 
            + '&page=' + this.options.page_to_load 
            + '&lang=' + this.options.lang

        return await axios.get(url).then((response) => {
            let listResponse = response.data;
            listResponse.forEach(item => {
                let clonedItem = this.options.item.cloneNode(true)
                const link = item.link
                
                if(this.options.title != undefined){
                    const title = item.title.rendered
                    clonedItem.querySelector(this.options.title).textContent = title
                }
                if(this.options.excerpt != undefined){
                    const excerpt = item.excerpt.rendered
                    clonedItem.querySelector(this.options.excerpt).innerHTML = excerpt
                }
                if(this.options.date != undefined){
                    const date = item.date.rendered
                    clonedItem.querySelector(this.options.date).innerHTML = date
                }
                if(this.options.image != undefined){
                    const image = this.getImage(item.featured_media) 
                        || window.location.host + '/wp-content/themes/iawp-child/assets/img/placeholder-horizontal.png' 
                        || window.location.host + '/wp-content/themes/iawp/assets/img/placeholder-horizontal.png'
                    clonedItem.querySelector(this.options.image).src = image
                }                
                clonedItem.querySelector('a').href = link

                const parent = this.options.item.parentElement;
                parent.appendChild(clonedItem);
                if(!!document.querySelector('.ia-block-spinner')){
                    document.querySelector('.ia-block-spinner').remove()
                }
            });
        })
    }

    async getImage(id) {
        return await axios.get('/wp-json/wp/v2/media/' + id).then((response) => {
            let imageSize = response.data.media_details.sizes;
            imageSize = (imageSize.large)?imageSize.large:imageSize.full
            return imageSize.source_url
        }).catch((error)=>{
        })
    }

    addLoader(item) {
        const loader = document.createElement('span')
        loader.classList.add('ia-block-spinner')
        loader.classList.add('active')
        item.append(loader)
    }
}